const allSubNavItems = (companyUrl, jobCount, reviewCount) => {
    return {
        overview: {
            name: 'Overview',
            url: `/company-overview/${companyUrl}`,
        },
        jobs: {
            name: 'Jobs',
            url: `/company/jobs/${companyUrl}`,
            counter: jobCount,
        },
        benefits: {
            name: 'Benefits',
            url: `/company-benefits/${companyUrl}`,
        },
        reviews: {
            name: 'Reviews',
            url: `/company-reviews/${companyUrl}`,
            counter: reviewCount,
        },
        parental: {
            name: 'Parental Leave',
            url: `/parental-leave/${companyUrl}`,
        },
        worklife: {
            name: 'Work-Life Balance',
            url: `/work-life-balance-flexibility/${companyUrl}`,
        },
        more: {
            name: 'More',
        },
    };
};

//Menu Keys
const sponsorKeys = {
    menuKeys: ['overview', 'jobs', 'benefits', 'reviews'],
    dropDownKeys: ['parental', 'worklife'],
};

const nonSponsorKeys = {
    menuKeys: ['overview', 'benefits', 'reviews', 'parental'],
    dropDownKeys: ['worklife'],
};

//Mobile Menu Keys
const sponsorMenuMobileKeys = sponsorKeys.menuKeys.concat(
    sponsorKeys.dropDownKeys
);
const nonSponsorMenuMobileKeys = nonSponsorKeys.menuKeys.concat(
    nonSponsorKeys.dropDownKeys
);

function getMenuWithMore(isSponsor, companyUrl, jobCount, reviewCount) {
    const keys = isSponsor ? sponsorKeys : nonSponsorKeys;
    const SubnavItems = allSubNavItems(companyUrl, jobCount, reviewCount);
    const moreItem = {
        name: 'More',
        dropdownItems: keys.dropDownKeys.map((key) => SubnavItems[key]),
    };
    return keys.menuKeys.map((key) => SubnavItems[key]).concat(moreItem);
}

//Mobile Props
export const subnavMobileMenuItems = (
    isSponser,
    companyUrl,
    jobCount,
    reviewCount
) => {
    const SubnavItems = allSubNavItems(companyUrl, jobCount, reviewCount);
    const mobileOptions = {
        sponsor: sponsorMenuMobileKeys.map((key) => SubnavItems[key]),
        nonSponsor: nonSponsorMenuMobileKeys.map((key) => SubnavItems[key]),
    };

    return mobileOptions[isSponser];
};

//Desktop Props
export const subnavMenuItems = (
    isSponser,
    companyUrl,
    jobCount,
    reviewCount
) => {
    const desktopOptions = {
        sponsor: getMenuWithMore(true, companyUrl, jobCount, reviewCount),
        nonSponsor: getMenuWithMore(false, companyUrl, jobCount, reviewCount),
    };

    return desktopOptions[isSponser];
};
